<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <b-card>
        <!--HEADER-->
        <b-row>
          <b-col>
            <h4>{{ $t('global.translations_list_titles') }}</h4>
          </b-col>
          <b-col md="auto">
            <b-button-group class="mb-3">
              <!-- <b-button variant="primary" :to="{ name: 'TranslationCreate' }">
                 {{ $t('global.translation_create_new') }}
               </b-button> -->
            </b-button-group>
          </b-col>
        </b-row>
        <!--HEADER END-->
        <hr>
        <div v-if="this.languagesClassifier.status !== statuses.LOADED
          || this.translationsList.status !== statuses.LOADED" class="text-center">
          <b-spinner type="grow" variant="primary"/>
        </div>
        <div v-else>
          <!--FILTERS-->
          <b-row>
            <b-col xl="6" md="12">
              <div>
                <b-form-group>
                  <b-input-group class="p-1">
                    <b-form-input :placeholder="$t('global.search')"
                      v-model="searchString"
                      v-on:keydown.enter="refreshTranslations(1)"/>
                    <b-input-group-append>
                      <b-button variant="primary"
                        @keyup.enter="refreshTranslations(1)"
                        @click="refreshTranslations(1)">
                        <i class="fa fa-search"/>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </div>
            </b-col>
            <b-col>
              <div class="mb-3 pull-right d-sm-flex mt-md-2">
                <b-form-checkbox switch class="mx-3 mt-1" variant="primary"
                  @input="refreshTranslations(1)"
                  v-model="selectUntranslated">
                  {{ $t('global.select_untranslated') }}
                </b-form-checkbox>
                <b-button-group size="sm">
                  <b-button :variant="selectedLangs.includes(refLangKey) ? 'info' : 'secondary'"
                    @click="onLangSelect(refLangKey)">{{ $t('global.sniffed') }}</b-button>
                  <template v-for="(lang, langId) in languageMap">
                    <b-button v-if="lang.key !== refLangKey" :key="langId"
                      :variant="selectedLangs.includes(lang.key) ? 'info' : 'secondary'"
                      @click="onLangSelect(lang.key, langId)">
                      {{ lang.name }}
                      <b-badge v-if="untranslated[langId]" variant="danger"> {{ untranslated[langId] }}</b-badge>
                    </b-button>
                  </template>
                </b-button-group>
              </div>
            </b-col>
          </b-row>
          <!--FILTERS END-->
          <!--TABLE-->
          <b-row>
            <b-col>
              <NoDataView v-if="!tableItems.length || !this.selectedLangs.length"/>
              <div v-else>
                <b-table class="table-sm text-center" :responsive="true" bordered
                  :fields="tableFields" :items="tableItems">
                  <template v-for="(lang, key) in languageMap" v-slot:[`cell(${key})`]="row">
                    <b-form-group v-if="activeRow === row.item.key_id && lang.key !== refLangKey" :key="key">
                      <b-input-group>
                        <b-form-input type="text" v-model="entity.langs[key]['text']"
                          :class="{ 'is-invalid'
                                        : errorMsg[activeRow] ? !!errorMsg[activeRow][key] : false }"
                          @input="saveTranslation(key)"/>
                        <b-input-group-append v-if="errorMsg[activeRow] ? !errorMsg[activeRow][key] : true">
                          <b-input-group-text>
                            <b-spinner v-if="spinners[key]" type="grow" small variant="success"/>
                            <i v-else class="fa fa-check color-success"></i>
                          </b-input-group-text>
                        </b-input-group-append>
                        <div class="invalid-feedback"
                          v-if="errorMsg[activeRow] ? errorMsg[activeRow][key]
                               ? errorMsg[activeRow][key]['text'] : false : false">
                          {{ errorMsg[activeRow][key]['text'][0] }}
                        </div>
                      </b-input-group>
                    </b-form-group>
                    <span v-else :key="key">
                        <text-highlight
                          :queries="/:[\w]{1,}/" highlightClass="translation_attribute" highlightStyle="">
                          {{ row.item['langs'][key] ? row.item['langs'][key]['text'] : '' }}
                        </text-highlight>
                      </span>
                  </template>

                  <template v-slot:cell(options)="row">
                    <a v-if="activeRow !== row.item.key_id && !disableEdit" @click="activateRow(row.item)">
                      <i class="mr-2 fa fa-edit fa-lg fa-pr fa-primary"/>
                    </a>
                    <i v-if="disableEdit" class="mr-2 fa fa-edit fa-lg fa-pr fa-disabled"/>
                    <a v-if="activeRow === row.item.key_id" @click="activeRow = null">
                      <i class="mr-2 fa fa-times fa-lg fa-pr fa-light-blue align-self-center"/>
                    </a>
                  </template>
                </b-table>
                <!--Paginator at bottom-->
                <Pagination  v-if="tableItems.length" :data="listPaginator" :limit="5"
                  @pagination-change-page="onPageChange"/>
              </div>
            </b-col>
          </b-row>
        </div>
        <!--TABLE END-->
      </b-card>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import statuses from '@/store/statuses';
import { mapActions, mapState } from 'vuex';
import Pagination from 'laravel-vue-pagination';
import VT from '@/store/types';
import NoDataView from '@/views/Shared/NoDataView.vue';
import TextHighlight from 'vue-text-highlight';

Vue.component('text-highlight', TextHighlight);
export default {
  mounted() {
    this.searchString = this.$route.query.search || '';
    this.selectUntranslated = this.$route.query.untranslated === true || false;
    this.selectedLangs = this.$route.query.langs ? this.$route.query.langs.split('|') : [];

    if (!this.$route.query.langs && this.selectedLangs.length < 3 && !this.selectedLangs.includes(this.refLangKey)) {
      this.selectedLangs.push(this.refLangKey);
    }
    if (this.languagesClassifier.status === statuses.LOADED) {
      this.getTranslations(true);
      this.getUntranslated();
    }
  },
  props: ['page'],
  data() {
    return {
      selectedLangs: [],
      selectUntranslated: false,
      searchString: '',
      refLangKey: 'xx',
      statuses: statuses,
      spinners: {
        contentIsLoading: true,
        tableIsLoading: true,
      },
      defaultTableFieldsA: [
        { key: 'group', label: this.$t('global.translation_group_label') },
        { key: 'key_id', label: this.$t('global.translation_key_id_label') },
      ],
      defaultTableFieldsB: [
        { key: 'options', label: this.$t('options', 'global'), tdClass: 'align-middle' }
      ],
      untranslated: {},
      untranslatedLoading: false,
      entity: {
        group: '',
        key: '',
        langs: {},
      },
      activeRow: null,
      errorMsg: {},
      timeoutId: null
    };
  },
  components: {
    Pagination, NoDataView
  },
  computed: {
    ...mapState('Languages', [
      'languagesClassifier',
    ]),
    ...mapState('Translations', [
      'translationsList'
    ]),
    languageMap() {
      if (typeof this.languagesClassifier.data === 'undefined') return [];
      return this.languagesClassifier.data.reduce((map, obj) => {
        map[obj.id] = obj;
        return map;
      }, {});
    },
    listPaginator() {
      return Object.is(this.translationsList, undefined) ? {} : this.translationsList.data.meta;
    },
    disableEdit() {
      return this.selectedLangs.includes(this.refLangKey) && this.selectedLangs.length === 1;
    },
    tableFields() {
      const fields = Object.keys(this.languageMap).reduce((arr, langId) => {
        if (!this.selectedLangs.includes(this.languageMap[langId].key)) return arr;
        const field = { key: `${langId}`, label: this.languageMap[langId].name };
        arr = this.languageMap[langId].key === this.refLangKey ? [field, ...arr] : [...arr, field];
        return arr;
      }, []);
      return [...this.defaultTableFieldsA, ...fields, this.defaultTableFieldsB];
    },
    tableItems() {
      if (typeof this.translationsList.data.data === 'undefined') return [];
      return this.translationsList.data.data.reduce((arr, obj) => {
        const row = JSON.parse(JSON.stringify(obj));
        row.langs = obj.translations.reduce((map, obj) => {
          map[obj.language_id] = obj;
          return map;
        }, {});
        delete row.translations;
        return [...arr, row];
      }, []);
    },
  },
  watch: {
    page: 'getTranslations',
    'languagesClassifier.status'() {
      if (this.languagesClassifier.status === statuses.LOADED) {
        this.getTranslations(true);
        this.getUntranslated();
      }
    }
  },
  methods: {
    ...mapActions('Translations', [
      VT.TRANSLATIONS_LIST,
      VT.UNTRANSLATED,
      VT.TRANSLATION_UPDATE,
    ]),

    onPageChange(page) {
      page = page || this.page;
      if (this.page === page) return;
      this.refreshTranslations(page);
    },
    refreshTranslations(page) {
      page = page || this.page;
      const query = {};
      if (this.searchString.length) { query['search'] = this.searchString; }
      query['untranslated'] = this.selectUntranslated;
      query['langs'] = this.selectedLangs.join('|');
      if (this.page === page) this.getTranslations();

      this.$router.push({ name: 'Translations', params: { page }, query }).catch(() => {
        /* probable redundant navigatino query */
      });
    },

    getTranslations(isInitial) {
      isInitial = isInitial === true || false;
      // Select at least 3 langs at first
      if (isInitial && typeof this.languagesClassifier.data !== 'undefined') {
        this.languagesClassifier.data.forEach((lang) => {
          if (this.$route.query.langs || this.selectedLangs.length >= 3) return;
          if (!this.selectedLangs.includes(lang.key)) {
            this.selectedLangs.push(lang.key);
          }
        });
      }
      if (this.selectedLangs.length === 0) return;
      const params = {
        page: this.page,
        langs: this.selectedLangs,
        selectUntranslated: this.selectUntranslated,
      };
      if (this.searchString.length) {
        params['searchString'] = this.searchString;
      }
      this.TRANSLATIONS_LIST(params);
    },
    getUntranslated() {
      if (this.untranslatedLoading) return;
      this.untranslatedLoading = true;
      this.UNTRANSLATED().then((response) => {
        this.untranslated = response.data;
        this.untranslatedLoading = false;
      });
    },
    onLangSelect(langKey) {
      const index = this.selectedLangs.indexOf(langKey);
      this.activeRow = {};
      if (index === -1) {
        this.selectedLangs = langKey === this.refLangKey
          ? [langKey, ...this.selectedLangs] : [...this.selectedLangs, langKey];
      } else {
        this.selectedLangs.splice(index, 1);
      }
      this.refreshTranslations();
    },
    activateRow(item) {
      this.activeRow = item.key_id;
      this.entity = item;
    },
    saveTranslation(languageId) {
      Vue.set(this.spinners, languageId, true);
      const data = {
        key: this.entity['key'],
        group: this.entity['group'],
        language_id: languageId,
        text: this.entity['langs'][languageId]['text'],
      };
      if (this.timeoutId) {
        clearTimeout(this.timeoutId);
        this.timeoutId = null;
      }
      this.timeoutId = setTimeout(async () => {
        try {
          await this.TRANSLATION_UPDATE(data);
          this.errorMsg = {};
        } catch (err) {
          if (!this.errorMsg[this.activeRow]) {
            this.errorMsg[this.activeRow] = {};
          }
          Vue.set(this.errorMsg[this.activeRow], languageId, err.data.data.errors);
        }
        this.timeoutId = null;
        Vue.set(this.spinners, languageId, false);
      }, 500);
    },
  }
};
</script>

<style  lang="scss">
  .form-group {
    margin-bottom: 0rem;
  }

  mark.translation_attribute {
    color: $primary;
    background: inherit;
    border-radius: inherit;
  }
</style>
